export const PII_RETRY = 'PII_RETRY';
export const PII_RETRY_PENDING = 'PII_RETRY_PENDING';
export const PII_RETRY_FAILURE = 'PII_RETRY_FAILURE';
export const PII_RETRY_SUCCESS = 'PII_RETRY_SUCCESS';
